<!--
 * @Description: 品牌宣传与供应商服务
 * @Author: xiawenlong
 * @Date: 2026-04-02
-->

<template>
  <div class="SupplierService">
    <div class="title">
      <span>供应链金融服务</span>
    </div>
    <div class="content">
      <div v-for="(item, index) in dataList" :key="index" class="data-item">
        <div class="icon-wrapper">
          <img :src="item.icon" alt="" />
        </div>
        <div class="info">
          <div class="value">
            <span class="number">{{ item.value }}</span>
            <span class="unit">{{ item.unit }}</span>
          </div>
          <div class="label">{{ item.label }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      defaultDataList: [
        {
          icon: require('@/img/agriculture/square_icon1.png'),
          label: '供应链融资规模',
          key: 'supplyChainFinancing',
          value: '0',
          unit: '万元',
        },
        {
          icon: require('@/img/agriculture/square_icon2.png'),
          label: '在融余额',
          key: 'financingBalance',
          value: '0',
          unit: '万元',
        },
        {
          icon: require('@/img/agriculture/square_icon3.png'),
          label: '供应商覆盖数',
          key: 'supplierCoverageCount',
          value: '0',
          unit: '家',
        },
        {
          icon: require('@/img/agriculture/square_icon4.png'),
          label: '逾期率',
          key: 'overdueRate',
          value: '0.0',
          unit: '%',
        },
      ],
    }
  },
  computed: {
    dataList() {
      return this.defaultDataList.map(item => ({
        ...item,
        value: this.data[item.key] || item.value,
      }))
    },
  },
}
</script>

<style lang="scss" scoped>
@keyframes float-up-down {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-8px);
  }
}

.SupplierService {
  position: relative;
  height: 100%;
  box-sizing: border-box;

  .title {
    position: relative;
    width: 100%;
    height: 50px;
    background: url('~@/img/agriculture/title_bg.png') 100% 100%;
    border-radius: 7px 7px 0px 0px;
    font-weight: bold;
    font-size: 30px;
    color: #fefefe;
    line-height: 50px;
    padding-left: 47px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-right: 20px;

    span {
      position: relative;
      z-index: 9;
    }

    &::after {
      z-index: 8;
      content: '';
      position: absolute;
      left: 25px;
      bottom: 5px;
      width: 366px;
      height: 23px;
      background: url('~@/img/agriculture/title_line.png') 100% 100%;
    }
  }

  .content {
    height: calc(100% - 50px);
    width: 100%;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(2, 1fr);
    padding: 20px;
    box-sizing: border-box;
    gap: 20px;

    .data-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 8px;

      .icon-wrapper {
        width: 83px;
        height: 83px;
        display: flex;
        align-items: center;
        justify-content: center;

        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
          animation: float-up-down 3s ease-in-out infinite;
        }
      }

      .info {
        display: flex;
        flex-direction: column;
        align-items: center;

        .value {
          display: flex;
          align-items: baseline;

          .number {
            font-size: 36px;
            font-weight: bold;
            color: #fff;
            font-family: 'DIN Alternate', 'DIN', sans-serif;
            text-shadow: 0 2px 8px rgba(8, 141, 218, 0.4);
            background: linear-gradient(180deg, #ffffff 0%, #ffffff 40%, #5bc0f8 80%, #088dda 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
          }

          .unit {
            font-size: 21px;
            color: rgba(255, 255, 255, 0.8);
          }
        }

        .label {
          font-size: 19px;
          color: rgba(255, 255, 255, 0.8);
          white-space: nowrap;
        }
      }
    }
  }
}
</style>
